export const enum CardType {
  POD = 'P',
  SAS = 'S',
  DG = 'D',
}
